import SideNavbarItems from './SideNavbarItems'
import { useNavigate } from 'react-router-dom'
import useLogout from '../../../auth/hooks/useLogout'
import { FaSpinner } from 'react-icons/fa'

export default function SideNavbar() {
  const navigate = useNavigate()

  const { inProgress, handleOnLogout } = useLogout()

  return (
    <div className="sticky top-0 flex h-screen w-1/5 flex-col border-l-2 border-muted-600 bg-white p-4 md:w-1/6">
      <div>
        <SideNavbarItems
          to={'/minerals'}
          label={'المعادن'}
        />
        <SideNavbarItems
          to={'/countries/opportunities'}
          label={`الفرص الاستثمارية`}
        />{' '}
        <SideNavbarItems
          to={'/form'}
          label={`البيانات `}
        />{' '}
        <SideNavbarItems
          to={`/sponsors`}
          label={`الرعاة`}
        />
        <SideNavbarItems
          to={`/sponsors/requests`}
          label={`طلبات الرعاية`}
        />{' '}
        <SideNavbarItems
          to={`/`}
          label={`احصائيات`}
        />{' '}
           <SideNavbarItems
          to={`/reviewers`}
          label={'استبيان  '}
        />{' '}
      </div>
      <button
        type="button"
        onClick={handleOnLogout}
        disabled={inProgress}
        className="mt-auto flex w-full items-center gap-2 bg-danger-600 p-3 px-6 font-bold text-white"
      >
        {inProgress ? (
          <div className="flex items-center">
            <FaSpinner
              size={16}
              className="ml-4 animate-spin"
            />
            <span>جاري تسجيل الخروج...</span>
          </div>
        ) : (
          <span>تسجيل الخروج</span>
        )}
      </button>
    </div>
  )
}
